import { securityInvitationsLinkGetAsyncSlice } from './get';

export const {
	requestGetSecurityInvitationsLink,
	resetGetSecurityInvitationsLink
} = securityInvitationsLinkGetAsyncSlice.asyncActionCreators;
